import { render, staticRenderFns, recyclableRender, components } from "./personal-data-second.vue?vue&type=template&id=016ce6fd&scoped=true&"
var renderjs
import script from "./personal-data-second.vue?vue&type=script&lang=js&"
export * from "./personal-data-second.vue?vue&type=script&lang=js&"
import style0 from "./personal-data-second.vue?vue&type=style&index=0&id=016ce6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ce6fd",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/personal-data-second.vue"
export default component.exports